<div
  class="card-base p-0 relative flex flex-col h-full transition-[border-color,box-shadow,background-color] duration-200"
  [class.overflow-hidden]="hideOverflow()"
  [ngClass]="{
    'border-[hsl(var(--color-primary))]! ring-1 ring-[hsl(var(--color-primary))]': selected(),
    'border-l-0!': accentPosition() === 'left',
    'border-t-0!': accentPosition() === 'top',
  }"
>
  @if (accentPosition() === 'left' && (accentStyle() || secondaryAccentStyle())) {
  <div class="absolute left-0 top-0 bottom-0 pointer-events-none rounded-l-xl overflow-hidden z-1 w-6">
    @if (accentStyle()) {
    <div
      class="absolute left-0 top-0 bottom-0 w-{{ accentWidth() }} bg-{{ accentStyle() }}"
    ></div>
    }
    @if (secondaryAccentStyle()) {
      @if (secondaryAccentStyle() === 'forwarded') {
      <div
        class="absolute left-1 top-0 bottom-0 ribbon-forwarded-wavy pointer-events-auto"
        [title]="secondaryAccentTooltip() || ''"
      ></div>
      } @else {
      <div
        class="absolute left-1 top-0 bottom-0 w-{{ accentWidth() }} bg-{{ secondaryAccentStyle() }}"
        [title]="secondaryAccentTooltip() || ''"
      ></div>
      }
    }
  </div>
  } @else if (accentPosition() === 'top') {
    @if (accentStyle()) {
    <div
      class="absolute left-0 top-0 right-0 h-{{ accentWidth() }} bg-{{
        accentStyle()
      }} rounded-t-xl"
    ></div>
    }
    @if (secondaryAccentStyle()) {
    <div
      class="absolute top-1 left-0 right-0 h-{{ accentWidth() }} bg-{{ secondaryAccentStyle() }}"
      [title]="secondaryAccentTooltip() || ''"
    ></div>
    }
  }
  <!-- Conditionally render the modern header -->
  @if (headerText()) {
  <div class="card-header-modern" 
       [class.cursor-pointer]="collapsible()" 
       (click)="toggleCollapse()"
       (keydown.enter)="toggleCollapse()"
       tabindex="0">
    <div class="flex items-center gap-2">
      @if (icon()) {
      <div class="icon-wrapper">
        <lucide-icon
          [name]="icon()!"
          [size]="size() === 'sm' ? 14 : 16"
        ></lucide-icon>
      </div>
      } @switch (size() ) { @case ('sm') {
      <app-text size="base" weight="semibold">{{ headerText() }}</app-text>
      } @case ('md') {
      <app-heading level="h3" class="font-medium">{{
        headerText()
      }}</app-heading>
      } @default {
      <!-- Default to h2 for larger sizes -->
      <app-heading level="h3" class="font-semibold">{{
        headerText()
      }}</app-heading>
      } }
    </div>
    <div class="ml-auto flex items-center gap-1">
      @if (editable()) {
      <app-button
        variant="ghost"
        size="sm"
        iconColor="text-muted"
        [iconOnly]="true"
        icon="Pencil"
        (click)="edit.emit(); $event.stopPropagation()"
      />
      }
      @if (collapsible()) {
      <app-button
        variant="ghost"
        size="sm"
        [iconColor]="collapsed() ? 'text-muted transition-transform duration-300 rotate-180' : 'text-muted transition-transform duration-300'"
        [iconOnly]="true"
        icon="ChevronUp"
        (click)="toggleCollapse(); $event.stopPropagation()"
      />
      }
    </div>
  </div>
  }

  @if (collapsible()) {
  <!-- Smooth collapsible summary -->
  <div class="hv-collapse-grid" [class.is-open]="collapsed()">
    <div class="hv-collapse-inner">
      <div
        class="hv-collapse-summary"
        [class]="(overridePadding() ? '' : 'px-4 pb-4 pt-1') + (collapsed() ? ' cursor-pointer' : '')"
        [attr.tabindex]="collapsed() ? 0 : null"
        (click)="collapsed() && toggleCollapse()"
        (keydown.enter)="collapsed() && toggleCollapse()"
      >
        <ng-content select="[card-summary]"></ng-content>
      </div>
    </div>
  </div>
  }

  <!-- Single default <ng-content> slot so Angular projects content for both collapsible and static cards -->
  <div [class]="collapsible() ? (collapsed() ? 'hv-collapse-grid' : 'hv-collapse-grid is-open') : 'contents'">
    <div [class]="collapsible() ? 'hv-collapse-inner' : 'contents'">
      <div
        [class]="
          collapsible()
            ? (overridePadding() ? 'flex flex-col' : 'p-4 flex flex-col')
            : (overridePadding() ? 'flex-1 min-h-0 flex flex-col' : 'p-4 flex-1 min-h-0 flex flex-col')
        "
      >
        <ng-content></ng-content>
      </div>
    </div>
  </div>

  <div
    class="rounded-b-xl relative overflow-hidden"
    [ngClass]="footerVariant() === 'forwarded' ? 'bg-forwarded-low-contrast' : 'bg-surface-high'"
  >
    @if (footerVariant() === 'forwarded') {
      <div class="h-[2px] w-full bg-forwarded-horizontal"></div>
    }
    <ng-content select="[card-footer]"></ng-content>
  </div>
</div>
